<template>
<Breadcrumbs main="Card" title="Card application" />
<div class="container-fliud">
   <h5>Order new cards</h5>
   <div class="mb-4">
       <label class="form-label" v-if="isSubmit == false">{{isConfirmed ? 'Review your order' : 'Number of cards (25 minimum)'}}</label>
       <div class="mb-3 d-flex input-container">
         <input 
           type="number" 
           class="form-control number-input-no-spinner " 
           v-model.number="cardCount" 
           v-if="!isConfirmed"
           min="25" 
         />
        <label class="checkResult" v-if="isConfirmed && isSubmit == false">{{ cardCount }} cards</label>
        <button class="edit-btn" @click="handleEdit" v-if="isConfirmed && isSubmit == false" :disabled="isLoading">Edit</button>
        <button class="confirm-btn" @click="handleConfirm" v-if="isSubmit == false" :disabled="isLoading">
          <span v-if="isLoading">Loading...</span>
          <span v-else>{{ isConfirmed ? 'Submit' : 'Confirm' }}</span>
        </button>
         
       </div>
       <p class="error-message" v-if="cardCount < 25">Minimum order not met</p>
       
   </div>
   <div v-if="isSubmit == true">
          <img src="@/assets/images/icon/Vector.svg" alt="vector">
          <label class="orderSubmitted">Order submitted</label>
         </div>
</div>
</template>

<script setup>
import { ref } from 'vue';
import { useCardStore } from '@/store/admin/card';

const cardStore = useCardStore();
const cardCount = ref();
const isConfirmed = ref(false);
const isSubmit = ref(false);
const isLoading = ref(false);
const handleConfirm = async () => {
    if(isConfirmed.value == true && cardCount.value >=25)
    {
       isLoading.value = true;
       try {
        const response = await cardStore.cardApplication(cardCount.value);
        
        if(response.success){
            isSubmit.value = true;
        }
       }
       catch(error){
        console.error('Error applying card:', error);
        throw error;
       }
       finally {
        isLoading.value = false;
       }
    }
    else if(cardCount.value >=25)
    {
        isConfirmed.value = true;
    }else{
        document.querySelector('.form-control').style.borderColor = 'red';
    }
    
    
}
const handleEdit = () =>{
    isConfirmed.value= false;
}
</script>

<style scoped>

.container-fliud {
    background-color:white;
    margin:0px 70px;
    border-radius: 5px;
    padding:30px;
}
.form-label{
    margin-top:40px;
}

.form-control{
    
    width: 220px ;
}
.confirm-btn{
    color:black;
    background-color:#00c962;
    border:none;
    border-radius:30px;
    padding:10px 40px;
    font-size:16px;
    margin-left:20px;
}

.confirm-btn:disabled{
    opacity: 0.6;
    cursor: not-allowed;
}

.edit-btn{
    border:none;
    background-color:white;
    color:rgb(124, 124, 218);
    font-size:16px;
}

.edit-btn:disabled{
    opacity: 0.5;
    cursor: not-allowed;
}
.checkResult{
    font-size:30px;
    margin-left:0px;
    margin-right:20px;
}
.error-message{
    color:red;
    font-size:16px;
    margin-top:10px;
}
.orderSubmitted{
    font-size:20px;
    margin-left:10px;
}
/* 移除 number input 的上下箭頭 */
.number-input-no-spinner {
  /* Firefox */
  -moz-appearance: textfield;
  appearance: textfield;
}

.number-input-no-spinner::-webkit-outer-spin-button,
.number-input-no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

/* 手機版響應式設計 */
@media (max-width: 768px) {
  .container-fliud {
    margin: 0px 15px;
    padding: 20px;
  }

  .form-label {
    margin-top: 20px;
    font-size: 14px;
  }

  .input-container {
    flex-direction: column;
    gap: 15px;
  }

  .form-control {
    width: 100%;
  }

  .checkResult {
    font-size: 24px;
    margin-right: 0;
  }

  .confirm-btn {
    width: 100%;
    margin-left: 0;
    padding: 12px 40px;
  }

  .edit-btn {
    width: 100%;
    padding: 8px;
    text-align: center;
  }

  .orderSubmitted {
    font-size: 18px;
    display: block;
    margin-top: 10px;
  }

  .error-message {
    font-size: 14px;
  }

  h5 {
    font-size: 18px;
  }
}

/* 小手機版 (小於 576px) */
@media (max-width: 576px) {
  .container-fliud {
    margin: 0px 10px;
    padding: 15px;
  }

  .checkResult {
    font-size: 20px;
  }

  .confirm-btn {
    font-size: 14px;
    padding: 10px 30px;
  }

  .orderSubmitted {
    font-size: 16px;
  }
}
</style>